/**
 * SplashBackground — tytułowa plansza Capibara jako tło onboarding flow.
 *
 * Renderuje `title_splash.png` (1920×1080 hero image z assets/title/) jako
 * pełnoekranowe tło z subtle meadow-tint overlay'em dla czytelności tekstu
 * na zawartości na wierzchu (LoadingScreen spinner, modale wyboru avatara/
 * starter pet'ów).
 *
 * **Użycie:**
 *  - Pod `LoadingScreen` (faza `!saveLoaded` w App.tsx)
 *  - Pod `AvatarSelectorModal` (faza `!avatarSelected`)
 *  - Pod `StarterPetSelectorModal` (faza `!starterPetsChosen`)
 *
 * Modale onboarding mają już `bg-meadow-700/30 backdrop-blur-sm` — splash
 * jest pięknie widoczny przez tinted blur, nie wymaga dodatkowych edits
 * istniejących modali.
 *
 * **Stacking (Codex splash LOW 2 fix):**
 * Komponent renderuje własny stacking context przez `isolate`. Tło (`<img>`
 * + tint) siedzi w `z-0`, content nad spodem MUSI mieć `relative z-10`.
 * Bez `isolate` `z-0` mogłoby konkurować z innymi stacking contexts wyżej
 * (np. `#game` w body) i splash znikłby pod canvas Phaser. Ten wzorzec jest
 * też reusable — komponent działa identycznie wewnątrz dowolnego rodzica.
 *
 * **Preload:** `index.html` ma `<link rel="preload" href="/title/title_splash.png">`
 * — obrazek jest pobierany równolegle z bundle JS, więc pojawia się od razu
 * przy pierwszym paint.
 */
export function SplashBackground(): JSX.Element {
  return (
    <div className="fixed inset-0 z-0 isolate pointer-events-none">
      {/* Mobile portrait: 1920×1080 landscape obrazek z `object-cover` na
          portrait viewport przycina ~37% z każdej strony i zjada napis
          CAPIBARA (poza central safe zone 60%). `object-contain` skaluje
          obraz w całości — w pasach widać meadow bg-200/20 + body bg-meadow-200,
          ale logo + capibara zachowane. `landscape:object-cover` przywraca
          full-bleed look na desktop/tablet landscape. */}
      <img
        src="/title/title_splash.webp"
        alt=""
        aria-hidden="true"
        draggable={false}
        className="absolute inset-0 w-full h-full object-contain landscape:object-cover select-none"
      />
      {/* Subtle meadow tint — utrzymuje wibe gry i delikatnie przygasza splash
          żeby tekst LoadingScreen / przyciski modali były czytelne. */}
      <div className="absolute inset-0 bg-meadow-200/20" />
    </div>
  );
}
